import L from "leaflet";

export default () => {

    const dom = document.querySelector('[data-map]');
    if (dom) {

        const map = L.map(dom);
        const latlng = [
            parseFloat(dom.getAttribute('data-lat')),
            parseFloat(dom.getAttribute('data-lng'))
        ];

        L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: '<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'smokeydev/cl3dlifuy000s15ro8gcm4g07',
            tileSize: 512,
            zoomOffset: -1,
            accessToken: 'pk.eyJ1Ijoic21va2V5ZGV2IiwiYSI6ImNsM2RqOW0yZjAxbDIzcG1rNzhwa2RycW8ifQ.2STK26mUhWl5EK2s8FffWA'
        }).addTo(map);

        map.setZoom(16);
        map.setView(latlng)

        const marker = L.marker(latlng);
        marker.addTo(map);
    }

}
